import RecoverFreespins from "slotworks/state-machine/standard/states/recover-freespins";
import sgSandAnimation from "components/sg-sand-animation";

export default class SGRecoverFreespins extends RecoverFreespins {

    public onEnter(): void {
        super.onEnter();

        sgSandAnimation.playSandAnimation().execute();
    }
}
